// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"a036672f","61":"ac3b00e4","144":"9e26deb3","241":"0e05f490","509":"0e05f490","534":"05bc01df","894":"a1abab53"}[chunkId] + ".chunk.css";
};